/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1635
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 953 */"./1645/953")
r({
  target: "Math",
  stat: true,
  forced: o != Math.expm1
}, {
  expm1: o
})
